import React from "react"
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react"
import { Outlet, useLocation } from "react-router-dom"
import Link from "./Link"

export default function DevTest() {
  const location = useLocation()

  const getTabIndex = React.useCallback(() => {
    if (location.pathname.includes("/alerts")) {
      return 0
    } else if (location.pathname.includes("/tables")) {
      return 1
    } else if (location.pathname.includes("/buttons")) {
      return 2
    }
    return 0
  }, [location.pathname])

  return (
    <Tabs variant="base" index={getTabIndex()}>
      <TabList>
        <Tab>
          <Link
            to="/devtest/alerts"
            textDecoration="none"
            _hover={{
              textDecoration: "none",
            }}
          >
            Alerts
          </Link>
        </Tab>
        <Tab>
          <Link
            to="/devtest/tables"
            textDecoration="none"
            _hover={{
              textDecoration: "none",
            }}
          >
            Tables
          </Link>
        </Tab>
        <Tab>
          <Link
            to="/devtest/buttons"
            textDecoration="none"
            _hover={{
              textDecoration: "none",
            }}
          >
            Buttons
          </Link>
        </Tab>
        <Tab>
          <Link
            to="/devtest/responsive-styles"
            textDecoration="none"
            _hover={{ textDecoration: "none" }}
          >
            Responsive Styles
          </Link>
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}
